import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, Modal, Affix, DatePicker, Typography } from 'antd'
import CardDownload from '../../Components/DownloadData/CardDownload'
import TitleGlobal from '../../Components/Global/TitleGlobal'
import { useDispatch, useSelector } from 'react-redux'
import { ClearDownloadDataReducer, ObtenerArchivosDownloadDataReducer, RegisterUsersConnectedModulesReducer } from '../../Redux/Actions/DownloadData/DownloadData'
import SideMenu from '../../Components/Global/SideMenu'
import socket from '../../App/socket'
import { useIdleTimer } from 'react-idle-timer'
import NavegadorArriendos from '../../Components/Arriendos/NavegadorArriendos'
import dayjs from 'dayjs'
import CalendarStatus from '../../Assets/Images/Status/calendar-status.png'
import { SetDateFilterStatusReducer } from '../../Redux/Actions/Status/Status'
import '../../Styles/Components/DownloadData/PageDownload.css'
import { CalendarFilled, DownOutlined } from "@ant-design/icons";

const DownloadData = () => {
    const [showModal, setShowModal] = useState(true);
    const [dateYearMonth, setDateYearMonth] = useState(dayjs())
    const { Title } = Typography

    const dispatch = useDispatch()

    const timeout = 300000

    const {
        rex_data_user_logingrow,
        rex_data_permissions_user
    } = useSelector(({ loginGrow }) => loginGrow)

    const getDataDownloadData = () => {
        dispatch(ObtenerArchivosDownloadDataReducer())
        dispatch(ClearDownloadDataReducer())
    }

    useEffect(() => {
        socket.on('get-update-profile-types', (data_users) => {
            getDataDownloadData()
        })

        getDataDownloadData()
    }, [])

    useEffect(() => {
        socket.on('get-users-modules', (data_users) => {
            dispatch(RegisterUsersConnectedModulesReducer(data_users))
        })

        return () => {
            socket.emit('unreg-modules', { module: 'downloadData' }, { usuusuario: rex_data_user_logingrow.usuusuario })
            socket.off('get-users-modules')
            socket.off('get-update-profile-types')
        }
    }, [])

    const onIdle = () => {
        socket.emit('reg-status-modules', { module: 'downloadData' }, { usuusuario: rex_data_user_logingrow.usuusuario }, false)
    }
    const onActive = () => {
        socket.emit('reg-status-modules', { module: 'downloadData' }, { usuusuario: rex_data_user_logingrow.usuusuario }, true)
    }

    useIdleTimer({
        onIdle,
        onActive,
        timeout,
        throttle: 500
    })

    const {
        rex_data_users_online
    } = useSelector(({ users }) => users)

    const {
        rex_users_download_data_connected,
        rex_archivos_download_data,
    } = useSelector(({ downloadData }) => downloadData)

    // Check if user has 'peru.arriendos' permission
    const hasPeruArriendosPermission = rex_data_permissions_user?.some(permission => permission.pemslug === 'peru.arriendos');

    // Get all unique categories from available data
    const todasLasCategorias = [...new Set(rex_archivos_download_data.flatMap(item => item.categoriaarchivo.nombre.split(',')))];

    // Filter categories based on:
    // 1. User permissions (remove "Arriendo" if no peru.arriendos permission)
    // 2. Available data (only show categories that have actual data)
    const categoriasDisponibles = todasLasCategorias.filter(categoria => {
        // Check if user has permission for this category
        if (categoria === 'Arriendo' && !hasPeruArriendosPermission) {
            return false;
        }
        
        // Check if there's actual data for this category
        const tieneData = rex_archivos_download_data.some(item => 
            item.categoriaarchivo.nombre === categoria && item.ardmostrar === true
        );
        
        return tieneData;
    });

    // State for selected category
    const [dataapiaccess, setdataapiaccess] = useState('');

    // Set default category when categories or permissions change
    useEffect(() => {
        if (categoriasDisponibles.length === 0) {
            setdataapiaccess('');
            return;
        }

        // If current selection is still valid, keep it
        if (categoriasDisponibles.includes(dataapiaccess)) {
            return;
        }

        // Priority order for default selection
        let defaultCategory = '';
        
        if (hasPeruArriendosPermission && categoriasDisponibles.includes('Arriendo')) {
            defaultCategory = 'Arriendo';
        } else if (categoriasDisponibles.includes('Data Analytics')) {
            defaultCategory = 'Data Analytics';
        } else {
            defaultCategory = categoriasDisponibles[0];
        }

        setdataapiaccess(defaultCategory);
    }, [rex_archivos_download_data, rex_data_permissions_user, hasPeruArriendosPermission]);

    const datePickerRef = useRef(null);
    const [datePickerOpen, setDatePickerOpen] = useState(false);

    const handleDatePickerContainerClick = (e) => {
        // Evita que el evento se propague si ya se hizo click en el DatePicker
        if (e.target.closest('.ant-picker')) {
            return;
        }

        // Abre el DatePicker usando el estado
        setDatePickerOpen(true);
    };

    // Filter data for selected category
    const dataFiltrada = rex_archivos_download_data.filter(item => 
        item.categoriaarchivo.nombre === dataapiaccess && item.ardmostrar === true
    );

    return (
        <>
            <div className="Container-Main Container-File-Upload">

                <Row>
                    <Col span={24}>
                        <Affix offsetTop={36}>
                            <div className="Container-Button-Status" style={{"paddingTop":"0.3rem"}}>
                                <NavegadorArriendos />
                            </div>
                        </Affix>
                    </Col>
                </Row>
                
                {/* Only show category buttons if there are available categories */}
                {categoriasDisponibles.length > 0 && (
                    <Row>
                        <Col span={24}>
                            <Affix offsetTop={16}>
                                <div className="Container-Button-Status">
                                    {categoriasDisponibles.map(categoria =>
                                        <button
                                            key={categoria}
                                            className={`Button-Status ${dataapiaccess === categoria ? 'Active-Status-Button' : ''}`}
                                            onClick={() => setdataapiaccess(categoria)}
                                        >
                                            <span className="Text-Span">{categoria}</span>
                                            <span className="Text-Span-Table-Status">{categoria}</span>
                                            <div className="Circle-Button-Table-Status"></div>
                                        </button>
                                    )}
                                </div>
                            </Affix>
                        </Col>
                    </Row>
                )}

                <div className="Container-Main" style={{ paddingBottom: '0', paddingTop: '42px' }}>
                    <div style={{ "display": "flex", "justifyContent": "space-between" }}>
                        <div>

                        </div>
                        <div>
                            <Title
                                level={2}
                                className="Title-Global"
                            >
                                Descarga de Data
                            </Title>
                            <p className="Paragraph-Global" style={{ "marginTop": "0.7rem" }}>
                                {categoriasDisponibles.length > 0 
                                    ? "Recuerda que solo podrás visualizar los archivos que tienes disponible, pero solo podrás descargarlo desde tu desktop"
                                    : "No tienes archivos disponibles para descargar en este momento"
                                }
                            </p>
                        </div>
                        <div>
                            {dataapiaccess === 'Arriendo' && (
                                <div
                                    onClick={handleDatePickerContainerClick}
                                    className=''
                                    style={{
                                        "display": "flex",
                                        "alignContent": "center",
                                        "alignItems": "center",
                                        "background": "#2bcd92",
                                        "width": "100%",
                                        "position": "relative",
                                        "borderRadius": "1rem",
                                        "cursor": "pointer",
                                        "transition": "all 0.3s ease",
                                        "boxShadow": "0 2px 5px rgba(43, 205, 146, 0.3)",
                                        "border": "1px solid transparent"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = "#25b683";
                                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(43, 205, 146, 0.5)";
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.border = "1px solid #1a8c64";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = "#2bcd92";
                                        e.currentTarget.style.boxShadow = "0 2px 5px rgba(43, 205, 146, 0.3)";
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.border = "1px solid transparent";
                                    }}
                                >
                                    <div className='' style={{
                                        "display": "flex",
                                        "alignContent": "center",
                                        "justifyContent": "center",
                                        "padding": "10px 10px",
                                        "width": "100%"
                                    }}>
                                        <CalendarFilled style={{
                                            "color": "#ffffff",
                                            "marginRight": "5px",
                                            "fontSize": "16px"
                                        }} />
                                        <DatePicker
                                            ref={datePickerRef}
                                            inputReadOnly={true}
                                            size='small'
                                            className='DatePicker-Filter-Status1'
                                            allowClear={false}
                                            value={dateYearMonth}
                                            picker="month"
                                            open={datePickerOpen}
                                            onOpenChange={(open) => setDatePickerOpen(open)}
                                            popupClassName='DatePicker-Filter-Status-PopUp'
                                            suffixIcon={null}
                                            onChange={(date, dateString) => {
                                                dispatch(SetDateFilterStatusReducer(dateString))
                                                setDateYearMonth(dayjs(dateString))
                                                setDatePickerOpen(false) // Cierra el picker después de seleccionar
                                            }}
                                            style={{
                                                "margin": "0px 0 0 0 !important",
                                                "color": "#ffffff !important",
                                                "background": "transparent",
                                                "border": "none",
                                                "fontWeight": "500",
                                                "fontSize": "14px"
                                            }}
                                        />
                                        <DownOutlined style={{
                                            "color": "#ffffff",
                                            "marginLeft": "5px",
                                            "fontSize": "12px",
                                            "transition": "transform 0.3s ease"
                                        }} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Only show CardDownload if there are available categories and data */}
                {categoriasDisponibles.length > 0 && dataapiaccess && (
                    <Row gutter={0} style={{ marginTop: '0' }}>
                        <Col className="gutter-row" span={24}>
                            <CardDownload 
                                downloadData={dataFiltrada} 
                                dateYearMonth={dateYearMonth}
                            />
                        </Col>
                    </Row>
                )}

                {/* Show message when no data is available */}
                {categoriasDisponibles.length === 0 && (
                    <Row gutter={0} style={{ marginTop: '20px' }}>
                        <Col className="gutter-row" span={24} style={{ textAlign: 'center', padding: '40px' }}>
                            <div style={{ color: '#999', fontSize: '16px' }}>
                                No hay archivos disponibles para mostrar
                            </div>
                        </Col>
                    </Row>
                )}

                {rex_users_download_data_connected &&
                    <SideMenu
                        usersCurrentView={rex_users_download_data_connected}
                        usersAllConnected={rex_data_users_online}
                    />
                }
                
                <Modal
                    open={showModal}
                    title={<span className={`Text-Ok`}>¡Grow te recomienda!</span>}
                    width={300}
                    zIndex={100000000}
                    className='Modal-Create-Data-Control'
                    footer={[
                        <div key="footer" style={{ display: "flex", justifyContent: "center" }}>
                            <div className={`Button-Close Button-Ok`} onClick={() => setShowModal(false)}>
                                Ok
                            </div>
                        </div>
                    ]}
                >
                    <div className='Modal-Description'>
                        Para una mejor experiencia, te sugerimos abrir esta plataforma en Google Chrome
                    </div>
                </Modal>
            </div>
        </>
    )
}

export default DownloadData